<h2 mat-dialog-title id="dialog-upload-queued-title">{{ 'upload.queued.title' | translate }}</h2>
<div mat-dialog-content id="dialog-upload-queued-content">
  <p id="dialog-upload-queued-message">{{ 'upload.queued.message' | translate }}</p>
  <p *ngIf="data?.task_id" id="dialog-upload-queued-taskid">
    <strong id="dialog-upload-queued-taskid-label">{{ 'upload.queued.taskId' | translate }}:</strong> <span id="dialog-upload-queued-taskid-value">{{ data.task_id }}</span>
  </p>
  <p id="dialog-upload-queued-checktasks">{{ 'upload.queued.checkTasks' | translate }}</p>
</div>
<div mat-dialog-actions align="end" id="dialog-upload-queued-actions">
  <button mat-button mat-dialog-close color="primary" id="dialog-upload-queued-close">{{ 'common.close' | translate }}</button>
</div>
